//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SlideUpDown from "vue-slide-up-down";
export default {
  props: {
    // 父辈向子辈传参
    pageData: {
      type: Object,
      require: true,
      default: () => {},
    },
    sourceType: {
      type: String,
      default: () => "list",
    },
    limit: {
      type: Number,
      default: 12,
    },
    searchWords: {
      type: String,
      default: () => "",
    },
  },
  name: "productList",
  data() {
    return {
      sortByDialogStatus: false, //下拉框是否展示
      sortBySelect: null, //当前选中的
      sortActive: null, //默认排序索引
      sortByParams: null, //排序方式，被选中的选项收集
      filterProductType: [], //筛选的类型
      filterColor: [], //筛选的颜色
      filterParams: {}, //过滤条件
      filterColorDialogStatus: true, //颜色是否展示
      // filterDialogProductNum: "", // 筛选之后的产品
      productAttr: [],
      pageNo: 1, //当前页码
      // pageSize:4,//一页展示几条数据
      pagerCount: 5, //连续页码数
      isShowfilter: true,
      slideType: "slideLeft",
    };
  },
  created() {
    // 实例被创建之后执行代码
  },
  computed: {
    // 计算属性
    totalNum() {
      if (this.pageData?.paginate) {
        return this.pageData.paginate.total;
      }
      return this.pageData.total;
    },
    fliterSelectItem() {
      return this.productAttr.filter((item) => item.isSelect).concat(this.filterColor.filter((item) => item.isSelect));
    },
    breadCrumbs() {
      return this.$route.params.pathMatch.replace(".html", "").replace("-", " ").split("/");
    },
  },
  components: {
    // 组件的引用
    SlideUpDown,
  },
  methods: {
    // 方法
    async getTypeData() {
      try {
        let { code, data } = await this.$getProductType({ category_id: this.pageData.categoryId });
        if (code == 200000) {
          this.filterProductType = data.lists.map((item) => {
            return {
              value: item.attributeCode,
              title: item.name,
              isShow: true,
              options_frontend: item.optionsFrontend.map((childitem) => ({ name: item.attributeCode, title: childitem.optionValue, isSelect: false })),
            };
          });
          console.log(this.filterProductType, "this.filterProductType");
        }
        //对于刷新页面动作,处理地址栏中的默认选中值
        let _queryObj = this.$route.query;
        for (let key in _queryObj) {
          if (key != "page" && key != "category_id") {
            this.filterParams[key] = _queryObj[key];
          }
          if (key != "color" && key != "page" && key != "category_id") {
            this.defaultUrl(_queryObj[key], key);
          }
        }
        let tempType = this.filterProductType.map((item) => item.options_frontend);
        this.productAttr = tempType.flat();
      } catch (error) {
        console.log("获取产品的属性类型" + error);
      }
    },
    /**
     * @Author: liudanli 565478958@qq.com
     * @Date: 2023-05-25 17:42:10
     * @LastAuthor: liudanli 565478958@qq.com
     * @description: 针对用户刷新页面,从地址栏中获取已选中的属性，进行页面回显
     * @param {*} _queryObj
     * @param {*} key
     * @return {*}
     * @Description: Do not Description
     */
    defaultUrl(_queryObj, key) {
      if (!_queryObj) {
        return;
      }
      if (Array.isArray(_queryObj)) {
        //如果是数组
        _queryObj.forEach((item) => {
          this.filterProductType.forEach((item1) => {
            if (item1.value == key) {
              item1.options_frontend.forEach((item3) => {
                if (item3.title == item) {
                  item3.isSelect = true;
                }
              });
            }
          });
        });
      } else {
        if (key == "sort_key") {
          //地址里有 sort key
          this.pageData.sortBy.forEach((item) => {
            if (item.sortKey == _queryObj) {
              this.sortBySelect = item.title;
            }
          });
          return;
        }
        this.filterProductType.forEach((item1) => {
          if (item1.value == key) {
            item1.options_frontend.forEach((item3) => {
              if (item3.title == _queryObj) {
                item3.isSelect = true;
              }
            });
          }
        });
      }
      console.log(this.filterProductType, "chuli");
    },

    async getColorData() {
      try {
        let { code, data } = await this.$commonColor();
        const includesColorId = [
          "ash_brown",
          "beach_blonde",
          "chestnut_brown",
          "chocolate_brown",
          "dark_brown",
          "dirty_blonde18",
          "mochachino_brown",
          "off_black",
          "sterling_sliver",
          "vibrant_red",
          "walnut_brown",
        ];
        if (code == 200000) {
          this.filterColor = data.map((item) => ({
            value: item.id,
            title: item.name,
            isSelect: false,
            image: includesColorId.includes(item.id) ? require(`@/static/img/color/${item.id}.png`) : "",
          }));
          this.filterColor = data
            .map((item) => {
              if (includesColorId.includes(item.id)) {
                return {
                  value: item.id,
                  title: item.name,
                  isSelect: false,
                  image: require(`~/static/img/color/${item.id}.png`),
                };
              }
            })
            .filter((item2) => item2 !== undefined);
        }
        //默认选中fliter 筛选条件
        if (this.$route.query.color) {
          if (Array.isArray(this.$route.query.color)) {
            this.filterColor.forEach((item) => {
              this.$route.query.color.forEach((item2) => {
                if (item2 == item.value) {
                  item.isSelect = true;
                }
              });
            });
          } else {
            this.filterColor.forEach((item) => {
              if (item.value == this.$route.query.color) {
                item.isSelect = true;
              }
            });
          }
        }
      } catch (error) {
        console.log("获取产品的属性color" + error);
      }
    },
    //选中之后 处理筛选
    fliterDialogHandler() {
      //选中color
      let tempColor = this.filterColor.filter((item) => item.isSelect);
      let tempType = this.filterProductType.map((item) => item.options_frontend);
      this.productAttr = tempType.flat();
      console.log(tempType, "tempType");
      this.filterParams = {
        color: tempColor.map((item) => item.value),
      };
      tempType.forEach((item) => {
        let arr = [];
        let newitem = item.filter((val) => val.isSelect);
        if (newitem.length > 0) {
          newitem.forEach((val1) => {
            arr.push(val1.title);
            this.filterParams[val1.name] = arr;
          });
        }
      });
      this.filterProductList();

      console.log(this.filterParams, "选中的所有option");
    },
    /**
     * @Author: liudanli 565478958@qq.com
     * @Date: 2023-05-25 11:42:56
     * @LastAuthor: liudanli 565478958@qq.com
     * @description: 点击sorty by 进行排序
     * @param {*} index 选中的排序项
     * @return {*}
     * @Description: Do not Description
     */
    changeSortPopup(index) {
      console.log(index, "被选中的数据");
      this.sortActive = index;
      let params = {};
      params.sort_key = this.pageData.sortBy[index].sortKey;
      this.sortBySelect = this.pageData.sortBy[index].title;
      this.sortByParams = params;
      this.sortByDialogStatus = false;
      this.filterProductList();
    },

    /**
     * @Author: liudanli 565478958@qq.com
     * @Date: 2023-05-25 11:45:31
     * @LastAuthor: liudanli 565478958@qq.com
     * @description: 对于用户的筛选、排序操作更改url参数
     * @return {*}
     * @Description: Do not Description
     */
    filterProductList(type = 1) {
      try {
        //处理list
        if (this.sourceType == "list") {
          let params = {
            ...this.filterParams,
            ...this.sortByParams,
            category_id: this.pageData.categoryId,
          };
          if (type == 2) {
            params.page = this.pageNo;
          } else {
            params.page = 1;
          }
          //这儿为什么走地址替换呢,为了让重新走服务端渲染
          console.log(params, "替换地址的参数");
          try {
            this.$router.replace(
              { path: this.$route.path, query: { ...params } },
              () => {},
              () => {}
            );
          } catch (error) {
            console.log("捕获错误" + error);
          }
        }
        // 处理搜索;
        if (this.sourceType == "search") {
          let params = {
            q: this.$route.query.q,
          };
          if (type == 2) {
            params.page = this.pageNo;
          }
          try {
            this.$router.replace(
              { path: this.$route.path, query: { ...params } },
              () => {},
              () => {}
            );
          } catch (error) {
            console.log("捕获错误" + error);
          }
        }
      } catch (error) {
        console.log("筛选/排序错误/搜索页面" + error);
      }
    },
    currentPageHandler(page) {
      this.pageNo = page;
      this.filterProductList(2);
    },
    /**
     * @Author: liudanli 565478958@qq.com
     * @Date: 2023-05-26 17:38:53
     * @LastAuthor: liudanli 565478958@qq.com
     * @description: 清除所有选中
     * @return {*}
     * @Description: Do not Description
     */
    clearSelectItemsHandler(type = 1) {
      this.productAttr.forEach((item) => (item.isSelect = false));
      this.filterColor.forEach((item) => (item.isSelect = false));
      this.filterProductType.forEach((item) => {
        console.log(item, "item");
        item.options_frontend.forEach((item1) => {
          item1.isSelect = false;
        });
      });
      //  console.log(this.filterProductType.items,'删除');
      if (type == 1) {
        this.fliterDialogHandler();
        this.googleCustomeEventHanlder("delete", "click", "filter");
      }
    },
    /**
     * @Author: liudanli 565478958@qq.com
     * @Date: 2023-05-26 17:58:43
     * @LastAuthor: liudanli 565478958@qq.com
     * @description: 删除选中项
     * @return {*}
     * @Description: Do not Description
     */
    fliterSelectToggleHandler(item) {
      item.isSelect = !item.isSelect;
      this.fliterDialogHandler();
    },
    handleFilterShow() {
      console.log(this.isShowfilter);
      this.isShowfilter = !this.isShowfilter;
    },
  },
  mounted() {
    // 页面进入时加载内容
    console.log(this.pageData, "列表页面数据");
    if (this.sourceType == "list") {
      this.sortActive = this.pageData.sortBy.findIndex((item) => item.title == this.pageData.defaultSortBy.toUpperCase());
      this.getTypeData();
      this.getColorData();
    }
  },
  beforeDestroy() {},
  watch: {
    // 监测变化
    $route: {
      handler(val) {
        if (JSON.stringify(val.query) == "{}" && this.productAttr.length > 0) {
          this.clearSelectItemsHandler(2);
        }
      },
      // 深度观察监听
      deep: true,
      immediate: true,
    },
  },
};
